import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, Form, Field } from "redux-form";

import _ from 'lodash';
import Select from 'react-select';
import Table from "rc-table";
import "rc-table/assets/index.css";

import { SYSTEM_VERSION } from "../../../../../config/consts";

import {
	setFormValue,
	create_or_update
} from "../../../../../helpers/formComponent";
import { setLoading } from "../../../../../helpers/redux";

import {
	ContentHeader,
	Content,
} from "../../../../../common/components/layout";
import Tabs from "../../../../../common/components/tabs/tabs";
import Card from "../../../../../common/components/ui/card/card";
import Button from "../../../../../common/components/ui/button/button";
import { ErrorModal } from "../../../../../common/components/ui/modals";

import types from "../rulesTypes";
import fields from "./fields";
import { getDetail, setDetail, create, update } from "../rulesActions";
import { getListAll as getPermissions } from "../../permissions/permissionsActions";

const permissionsColumns = [
	{
		title: "Nome",
		dataIndex: "name",
		key: "name",
	},
	{
		title: "Descrição",
		dataIndex: "description",
		key: "description"
	},
];

export class RulesForm extends Component {
	constructor(props) {
		super(props);
		this.props.getPermissions();
		this.state = {
			visible: false,
			deletedItem: {},
			selectedPermissions: []
		}

		const {
			rules, router, location, getDetail, setDetail, setLoading
		} = this.props;

		setLoading(types.RULES_LOADING, true);
		setFormValue(rules, router, location, getDetail, setDetail);
	}

	onSubmit = values => {
		const { router, create, update } = this.props;
		create_or_update(router, values, create, update);
	}

	savePermissions = () => {
		const permissions = [
			...this.props.rules.detail.permissions,
			...this.state.selectedPermissions.map(item => item.object)
		];

		const result = Array.from(new Set(permissions.map(item => item._id)))
			.map(id => {
				return permissions.find(x => x._id === id)
			})
		const values = {
			_id: this.props.router.params.id,
			permissions: result
		}
		this.props.update(values);
		this.setState({
			visible: false,
			deletedItem: {},
			selectedPermissions: []
		});
	}

	showModalDelete = (item) => {
		this.setState({
			visible: true,
			deletedItem: item
		});
	}

	hideDelete = () => {
		this.setState({
			visible: false,
			deletedItem: {}
		});
	}

	onDelete = () => {
		const permissions = this.props.rules.detail.permissions.filter((item) => item._id !== this.state.deletedItem._id);
		const values = {
			_id: this.props.router.params.id,
			permissions: permissions
		}
		this.props.update(values);
		this.setState({
			visible: false,
			deletedItem: {},
			selectedPermissions: []
		});
	}


	handlePermissionsChange = (selectedPermissions) => {
		this.setState({ selectedPermissions });
	}

	renderFields = () => {
		return fields().map((item, index) => (
			<Field {...item} key={index} />
		));
	};

	renderOptionsPermissions = () => {
		const added = this.props.rules.detail.permissions || [];
		let options = this.props.permissions.list.content.map((item) => {
			const supportList = added.filter(x => x._id === item._id);
			if( supportList.length === 0) {
				return {
					label: item.name,
					value: item._id,
					object: item
				}
			} return null;
		});

		return options.filter(item => item !== null);

	}

	renderColumns = () => {
		const { Column } = Table;
		const headers = permissionsColumns.map((item, index) => (
			<Column className="table__column" {...item} key={index} />
		));

		headers.push(
			<Column
				title="Ações"
				dataIndex="actions"
				className="table__column"
				key={headers.length}
				render={(text, record) => (
					<div style={{cursor: 'pointer', padding: '0 1rem'}} onClick={() => this.showModalDelete(record)}>
						<i className="fa fa-trash-o" style={{ fontSize: '1.6rem', color: 'red'}} />
						<span style={{display: 'none'}}>Excluir</span>
					</div>
					// <TableActions
					// 	customID={this.props.customID || 'id'}
					// 	key="action"
					// 	item={record}
					// 	router={this.props.router}
					// 	deleteitem={item => this.showDelete(item)}
					// 	detailitem={item => this.showDetail(item)}
					// 	actions_permissions={actions_permissions}
					// />
				)}
			/>
		);

		return headers;
	}

	renderForm = () => {
		const { handleSubmit } = this.props;
		return (
			<Card header title="Formulário">
				<Form
					role="form"
					onSubmit={handleSubmit(this.onSubmit)}
					noValidate
				>
					<div className="form__body">
						{this.renderFields()}
					</div>
					<div className="form__footer">
						<div className="form__footer--actions">
							<Button
								text="Cancelar"
								type="button"
								rounded
								colors={"#f1c40f"}
								textStyle={{ color: "#555" }}
								outline
								onClick={() =>
									this.props.router.goBack()
								}
							/>
							<Button
								text="Salvar"
								type="submit"
								// style={{ width: "25%" }}
								rounded
								buttonType="primary"
								textStyle={{ color: "#555" }}
								outline
								// animated
							/>
						</div>
					</div>
				</Form>
			</Card>
		)
	}

	renderPermissions = () => {
		return (
			<div>
				<Card header title="Filtros e opções" withoutBorder>
					<div style={{display: 'flex', flex: 1, height: '4rem'}}>
						<div style={{flex: 10}}>
							<Select
								value={this.state.selectedPermissions}
								onChange={this.handlePermissionsChange}
								closeMenuOnSelect={false}
								isMulti
								options={this.renderOptionsPermissions()}
							/>
						</div>
						<div style={{flex:2}}>
							<Button
								onClick={this.savePermissions}
								text='Adicionar'
								rounded
								buttonType='primary'
								textStyle={{color: '#555'}}
								outline
							/>
						</div>
					</div>
				</Card>
				<Card>
					<div style={{display: 'flex', flex: 1}}>
						<div style={{flex: 1, alignContent: 'flex-start', alignItems: 'flex-start', justifyContent: 'flex-start'}}>
							<h3 className="card-title">Permissões</h3>
						</div>
					</div>
					<div>
						<Table
							data={this.props.rules.detail.permissions}
							rowKey='_id'
						>
							{this.renderColumns()}
						</Table>
					</div>
				</Card>
				<ErrorModal
					isVisible={this.state.visible}
					btnCancel={{
						text: 'Cancelar',
						onClick: this.hideDelete
					}}
					btnOk={{
						text: 'Excluir',
						onClick: this.onDelete
					}}
				/>
			</div>
		)
	}

	renderBody = () => {
		if(_.isUndefined(this.props.router.params.id)) {
			return this.renderForm();
		}

		return (
			<Tabs
				tabs={[
					{
						headers:{
							title: 'Informações'
						},
						body: this.renderForm()
					},
					{
						headers:{
							title: 'Permissões do papel'
						},
						body: this.renderPermissions()
					}
				]}
			/>
		)
	}

	render() {
		
		return (
			<div>
				<ContentHeader
					title="Papéis"
					small={`Versão ${SYSTEM_VERSION}`}
				/>
				<Content>
					{this.renderBody()}
				</Content>
			</div>
		);
	}
}

RulesForm = reduxForm({ form: "rulesForm" })(RulesForm);

const mapStateToProps = state => {
	return {
		rules: state.rules,
		permissions: state.permissions
	};
};

const mapDispatchToProps = dispatch => ({
	...bindActionCreators(
		{
			getDetail,
			setDetail,
			create,
			update,
			setLoading,
			getPermissions
		},
		dispatch
	)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RulesForm);
